import KeyMirror from "keymirror";

export default KeyMirror({
  START_LOADING: null,
  END_LOADING: null
});
